<ion-list class="ion-no-padding">
  <!-- List Header Divider -->
  <ion-item-divider color="light">
    <!-- Optional Image -->
    <!-- <img class="list-header-img" src="assets/imgs/sport_types/{{ eventType }}.png"> -->
    <ion-label class="primary text-uppercase">
      {{ container.eventArea }}
    </ion-label>
  </ion-item-divider>

  <!-- List Items -->
  <ion-item *ngFor="let item of container.items" (click)="openEventDetails(item)">
    <ion-avatar slot="start">
      <img [src]="spooortsDomain+item.imgPath" alt="Avatar" />
    </ion-avatar>

    <!-- Conditional Layout: Events -->
    <ion-label class="label-flex-row">
      <ion-row *ngIf="type === 'Events'" class="ion-justify-content-between">
        <ion-col size="auto">
          <h4 class="event-date">{{ item.dateFormatted }}</h4>
        </ion-col>

        <ion-col size="auto" *ngIf="item.eventType?.includes('V')">
          <h4 class="event-date">{{ item.distance }}</h4>
        </ion-col>

        <ion-col size="auto" *ngIf="item.eventStatus?.includes('C')">
          <h4 class="event-date" style="margin-left: -80px;">
            {{ item.distance }}
          </h4>
        </ion-col>

        <ion-col size="auto" *ngIf="item?.eventStatus?.includes('C')">
          <h4 style="color: red;">{{ getEventStatus(item) }}</h4>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="type === 'Events'">
        <ion-col>
          <h4 class="text-nowrap event-name">{{ item.eventName }}</h4>
        </ion-col>
      </ion-row>

      <!-- Conditional Layout: Not Events -->
      <ion-row *ngIf="type !== 'Events'" class="ion-justify-content-between">
        <ion-col size="auto">
          <h4 class="event-date">{{ item.dateFormatted }}</h4>
        </ion-col>
        <ion-col>
          <h4 class="event-name">{{ item.eventName }}</h4>
        </ion-col>
      </ion-row>
    </ion-label>
  </ion-item>

  <!-- Expand Button -->
  <ion-item *ngIf="containerIndex" lines="none" class="ion-text-center" class="btn-centered-container">
    <ion-button expand="block" class="centered-btn" (click)="onExpandContainer()">{{"ALL_EVENTS" | translate}}</ion-button>
  </ion-item>
</ion-list>

<!-- <ion-list>
    <ion-item-divider class="list-header" color="light">

        <div class="primary">{{ container.eventArea|uppercase }}</div>
    </ion-item-divider>
    <ion-item class="list-item button-flex" *ngFor="let item of container.items" (click)="openEventDetails(item)">
        <ion-avatar item-start>
            <img src="{{item.imgPath}}">
        </ion-avatar>
        <ion-row *ngIf="type === 'Events'" class="flex-space-between">
            <h4 class="event-date">{{ item.dateFormatted }}</h4>
            <h4 class="event-date" *ngIf="item.eventType && item.eventType.includes('V')">{{ item.distance }}</h4>
            <h4 class="event-date" *ngIf="item.eventStatus.includes('C')" style="margin-left: -80px;">
                {{ item.distance }}</h4>
            <h4 style="color:red" *ngIf="item?.eventStatus.includes('C')">{{ getEventStatus(item) }}</h4>
        </ion-row>

        <ion-row *ngIf="type === 'Events'">
            <h4 text-nowrap>{{ item.eventName }}</h4>
        </ion-row>

        <ion-row *ngIf="type !== 'Events'">
            <h4 class="event-date">{{ item.dateFormatted }}</h4>
            <h4 class="event-name">
                {{ item.eventName }}</h4>
        </ion-row>
    </ion-item>
    <ion-item class="text-center" *ngIf="containerIndex">
        <button ion-button (click)="onExpandContainer()">ALLE EVENTS</button>
    </ion-item>
</ion-list> -->